import { useQuery } from '@apollo/client'
import {
  PasswordResetGetQuery,
  PasswordResetGetQueryVariables,
} from 'src/generated'

import QUERY from './query.gql'

/**
 * What a password reset link says. Anonymous: whoever opens it cannot sign in,
 * which is why they are here.
 */
export const usePasswordResetGetQuery = (token: string | null) =>
  useQuery<PasswordResetGetQuery, PasswordResetGetQueryVariables>(QUERY, {
    variables: { input: { token: token ?? '' } },
    skip: !token,
    // Read once per visit and never shared: whether a link still works is the
    // answer, and a cached `valid` would offer a form that can only fail.
    fetchPolicy: 'no-cache',
    context: { anonymous: true },
  })
